export function getCreateLabelInitValues(entity) {
  return {
    entities: [entity],
  }
}
